import { categories } from '@/mocks/categories';

const footerLinks = {
  categories: categories.slice(0, 6).map((c) => ({
    label: c.name,
    url: c.url,
    external: true,
  })),
  guides: [
    { label: 'What Is LitBuy Spreadsheet', url: '/article/what-is-litbuy-spreadsheet', external: false },
    { label: 'Spreadsheet Guides', url: '/article/what-is-litbuy-spreadsheet', external: false },
    { label: 'Comparison Center', url: '/article/what-is-litbuy-spreadsheet', external: false },
    { label: 'Beginner Tutorials', url: '/article/what-is-litbuy-spreadsheet', external: false },
  ],
  legal: [
    { label: 'Safety & Disclaimer', url: '/article/what-is-litbuy-spreadsheet', external: false },
    { label: 'Privacy Policy', url: '/article/what-is-litbuy-spreadsheet', external: false },
    { label: 'Terms of Use', url: '/article/what-is-litbuy-spreadsheet', external: false },
    { label: 'Cookie Policy', url: '/article/what-is-litbuy-spreadsheet', external: false },
  ],
  connect: [
    { label: 'KasPreadsheet Home', url: 'https://kaspreadsheet.com/', external: true },
    { label: 'About Us', url: '/article/what-is-litbuy-spreadsheet', external: false },
    { label: 'FAQ', url: '/article/what-is-litbuy-spreadsheet', external: false },
    { label: 'Contact', url: '/article/what-is-litbuy-spreadsheet', external: false },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
          {Object.entries(footerLinks).map(([key, links]) => (
            <div key={key}>
              <h4 className="font-heading text-sm font-semibold text-foreground-950 uppercase tracking-wider mb-4">
                {key}
              </h4>
              <div className="w-8 h-px bg-primary-400 mb-4"></div>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    {link.external ? (
                      <a
                        href={link.url}
                        target="_blank"
                        rel="noopener nofollow"
                        className="text-sm text-foreground-600 hover:text-primary-500 cursor-pointer transition-colors duration-200 whitespace-nowrap"
                      >
                        {link.label}
                      </a>
                    ) : (
                      <a
                        href={link.url}
                        className="text-sm text-foreground-600 hover:text-primary-500 cursor-pointer transition-colors duration-200 whitespace-nowrap"
                      >
                        {link.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div>
            <p className="font-heading text-4xl font-extrabold text-foreground-950 tracking-tight">
              LITBUY
            </p>
            <p className="font-heading text-4xl font-extrabold text-foreground-950 tracking-tight -mt-1">
              SPREADSHEET
            </p>
            <div className="w-12 h-px bg-primary-400 mt-2 mb-2"></div>
            <p className="text-xs text-foreground-500">The Complete LitBuy Spreadsheet Resource Center</p>
          </div>

          <div className="flex flex-col items-end gap-2">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} litbuyspreadsheets.mom. All rights reserved.
            </p>
            <div className="flex items-center gap-3">
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100 hover:bg-primary-100 text-foreground-500 hover:text-primary-500 cursor-pointer transition-all duration-200"
                aria-label="Visit KasPreadsheet"
              >
                <i className="ri-external-link-line"></i>
              </a>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100 hover:bg-primary-100 text-foreground-500 hover:text-primary-500 cursor-pointer transition-all duration-200"
                aria-label="Share"
              >
                <i className="ri-share-line"></i>
              </a>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100 hover:bg-primary-100 text-foreground-500 hover:text-primary-500 cursor-pointer transition-all duration-200"
                aria-label="Bookmark"
              >
                <i className="ri-bookmark-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}